/**
 * Convercus BI Service
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ComparisonDateRange } from './comparison-date-range';
import { ComparisonChangeKind } from './comparison-change-kind';
import { ResultFreshness } from './result-freshness';
import { CompareTo } from './compare-to';


export interface PeriodComparison { 
    /**
     * Which comparison this is.
     */
    type: CompareTo;
    /**
     * The dates the second run covered. The KPI\'s own period is cut at today whenever there is a comparison.
     */
    period: ComparisonDateRange;
    /**
     * How to show the change. relative (count, amount): (current - compared) / |compared|, no percentage when the compared value is 0 or null. points (percentage): (current - compared) × 100 as percentage points.
     */
    changeKind: ComparisonChangeKind;
    /**
     * Execution of the second run, polled like the KPI\'s own; read the value from the same column as the main row (count for count and amount KPIs, value for percentage). Absent when the run could not be queued.
     */
    executionId?: string;
    /**
     * Why the second run could not be queued. The KPI\'s own result is not affected.
     */
    error?: string;
    /**
     * Machine-readable reason for error, when it has one.
     */
    errorCode?: PeriodComparison.ErrorCodeEnum;
    /**
     * executeKpi with waitMs only: the second run\'s status after the wait, as the KPI\'s own status.
     */
    status?: PeriodComparison.StatusEnum;
    /**
     * fresh, stale or computing, as for the KPI\'s own run.
     */
    freshness?: ResultFreshness;
    /**
     * When the compared rows were computed, for an \"as of\" label.
     */
    computedAt?: string;
    /**
     * How long the latest warehouse run of this KPI version took, in milliseconds.
     */
    lastRunMs?: number;
    /**
     * True when that latest run took 5 s or more.
     */
    slow?: boolean;
}
export namespace PeriodComparison {
    export const ErrorCodeEnum = {
        DashboardNotFound: 'DASHBOARD_NOT_FOUND',
        KpiNotFound: 'KPI_NOT_FOUND',
        KpiAlreadyExists: 'KPI_ALREADY_EXISTS',
        KpiKeyAlreadyExists: 'KPI_KEY_ALREADY_EXISTS',
        KpiNameAlreadyExists: 'KPI_NAME_ALREADY_EXISTS',
        ProgramKpiNotFound: 'PROGRAM_KPI_NOT_FOUND',
        KpiExecutionNotFound: 'KPI_EXECUTION_NOT_FOUND',
        KpiExecutionFailed: 'KPI_EXECUTION_FAILED',
        KpiQueryTimeout: 'KPI_QUERY_TIMEOUT',
        KpiQuerySyntaxError: 'KPI_QUERY_SYNTAX_ERROR',
        DwhConnectionNotFound: 'DWH_CONNECTION_NOT_FOUND',
        DwhConnectionAlreadyExists: 'DWH_CONNECTION_ALREADY_EXISTS',
        DwhUnreachable: 'DWH_UNREACHABLE',
        DwhTableNotFound: 'DWH_TABLE_NOT_FOUND',
        AiCompletionNotFound: 'AI_COMPLETION_NOT_FOUND',
        DashboardFilterValueInvalid: 'DASHBOARD_FILTER_VALUE_INVALID',
        DashboardFilterUnknownField: 'DASHBOARD_FILTER_UNKNOWN_FIELD',
        DashboardFilterBindingInvalid: 'DASHBOARD_FILTER_BINDING_INVALID',
        DashboardDateRangeTooLarge: 'DASHBOARD_DATE_RANGE_TOO_LARGE',
        DashboardArchived: 'DASHBOARD_ARCHIVED',
        DashboardInvalidStatusTransition: 'DASHBOARD_INVALID_STATUS_TRANSITION',
        DashboardNotDeletable: 'DASHBOARD_NOT_DELETABLE',
        KpiArchived: 'KPI_ARCHIVED',
        KpiNotDeletable: 'KPI_NOT_DELETABLE',
        KpiInUse: 'KPI_IN_USE',
        KpiTrendFormatOutdated: 'KPI_TREND_FORMAT_OUTDATED',
        DashboardBundleInvalid: 'DASHBOARD_BUNDLE_INVALID',
        DashboardBundleUnsupportedVersion: 'DASHBOARD_BUNDLE_UNSUPPORTED_VERSION',
        KpiBundleInvalid: 'KPI_BUNDLE_INVALID',
        KpiBundleUnsupportedVersion: 'KPI_BUNDLE_UNSUPPORTED_VERSION',
        KpiImportFailed: 'KPI_IMPORT_FAILED',
        DashboardExportKeyConflict: 'DASHBOARD_EXPORT_KEY_CONFLICT',
        DashboardImportFailed: 'DASHBOARD_IMPORT_FAILED',
        DashboardViewNotFound: 'DASHBOARD_VIEW_NOT_FOUND',
        DashboardItemNotFound: 'DASHBOARD_ITEM_NOT_FOUND',
        DashboardReorderInvalid: 'DASHBOARD_REORDER_INVALID',
        KpiVersionNotFound: 'KPI_VERSION_NOT_FOUND',
        KpiConfigurationInvalid: 'KPI_CONFIGURATION_INVALID',
        KpiParameterInvalid: 'KPI_PARAMETER_INVALID',
        KpiInvalidStatusTransition: 'KPI_INVALID_STATUS_TRANSITION',
        KpiNotCloneable: 'KPI_NOT_CLONEABLE',
        KpiNotPublished: 'KPI_NOT_PUBLISHED',
        ArtifactNotFound: 'ARTIFACT_NOT_FOUND',
        ArtifactConfigurationInvalid: 'ARTIFACT_CONFIGURATION_INVALID',
        QueryRejected: 'QUERY_REJECTED',
        KpiLimitReached: 'KPI_LIMIT_REACHED',
        DashboardFilterTooManyOptions: 'DASHBOARD_FILTER_TOO_MANY_OPTIONS',
        QueryTimeout: 'QUERY_TIMEOUT',
        QueryCancelled: 'QUERY_CANCELLED',
        ArtifactExecutionMismatch: 'ARTIFACT_EXECUTION_MISMATCH',
        ArtifactQueryTooSlow: 'ARTIFACT_QUERY_TOO_SLOW',
        InternalServerError: 'INTERNAL_SERVER_ERROR',
        NotAuthorized: 'NOT_AUTHORIZED',
        Forbidden: 'FORBIDDEN',
        ValidationFailed: 'VALIDATION_FAILED',
        ProgramContextMissing: 'PROGRAM_CONTEXT_MISSING',
        OrganizationNotFound: 'ORGANIZATION_NOT_FOUND',
        ResourceNotFound: 'RESOURCE_NOT_FOUND',
        ResourceConflict: 'RESOURCE_CONFLICT'
    } as const;
    export type ErrorCodeEnum = typeof ErrorCodeEnum[keyof typeof ErrorCodeEnum];
    export const StatusEnum = {
        Error: 'error',
        Pending: 'pending',
        Running: 'running',
        Success: 'success',
        Generating: 'generating',
        Cancelled: 'cancelled'
    } as const;
    export type StatusEnum = typeof StatusEnum[keyof typeof StatusEnum];
}


